import { useState } from "react";
import { Button } from "@material-ui/core";

export const TwoFactorAuthForm = ({ verifyTwoFactorCode = () => {} }) => {
  const [state, setState] = useState({
    code: null,
  });
  return (
    <>
      <h2 className="inter inter-bold login-form-title">
        {window.sys_app_translate("Enter Two Factor Auth Code", "en")}
      </h2>
      <label style={{ marginTop: "25.3px", color: "#707070" }}>
        {window.sys_app_translate("Code", "en")}
      </label>
      <input
        type="text"
        className="form-control inter inter-semi-bold"
        onChange={(e) => {
          setState({ ...state, code: e.target.value });
        }}
      />
      <Button
        variant="contained"
        className="login-button inter inter-bold"
        onClick={(e) => {
          e.preventDefault();
          verifyTwoFactorCode(state.code);
        }}
      >
        {window.sys_app_translate("Submit", "en")}
      </Button>
    </>
  );
};
